import { EventTypes } from 'redux-segment';

import { GET_CATEGORIES_FAILURE, GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import USER_ROLE from 'constants/role';
import { AUTH_API } from 'middleware/api';
import { COGNITO_ATTRIBUTE } from 'utils/cognito.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import parseJson from 'utils/parsers/parseJson';

import {
  CLIENT_LIST_FAILURE,
  CLIENT_LIST_REQUEST,
  CLIENT_LIST_SUCCESS,
  EMAIL_PIN_FAILURE,
  EMAIL_PIN_REQUEST,
  EMAIL_PIN_SUCCESS,
  REMOVE_ACCESS_FAILURE,
  REMOVE_ACCESS_REQUEST,
  REMOVE_ACCESS_SUCCESS,
  REMOVE_FB_INTEGRATION_FAILURE,
  REMOVE_FB_INTEGRATION_REQUEST,
  REMOVE_FB_INTEGRATION_SUCCESS,
  RESET_PIN_FAILURE,
  RESET_PIN_REQUEST,
  RESET_PIN_SUCCESS,
  RESET_REMOVED_ACCESS,
  SALON_STATE_ERROR,
  SALON_STATE_REQUEST,
  SALON_STATE_SUCCESS,
  SET_REDIRECT_URI,
  SET_USER_PERMISSIONS,
} from 'salon/constants';

export const UPDATE_SALON_DATA_REQUEST = 'UPDATE_SALON_DATA_REQUEST';
export const UPDATE_SALON_DATA_SUCCESS = 'UPDATE_SALON_DATA_SUCCESS';
export const UPDATE_SALON_DATA_FAILURE = 'UPDATE_SALON_DATA_FAILURE';

export const SET_CURRENT_STYIST = 'SET_CURRENT_STYIST';

export const TOGGLE_ONLINE_BOARDING = 'TOGGLE_ONLINE_BOARDING';
export const CLEAR_COMPLETED_SAVE_SALON = 'CLEAR_COMPLETED_SAVE_SALON';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAILURE = 'PRODUCT_LIST_FAILURE';

export const GET_VERSION_REQUEST = 'GET_VERSION_REQUEST';
export const GET_VERSION_SUCCESS = 'GET_VERSION_SUCCESS';
export const GET_VERSION_FAILURE = 'GET_VERSION_FAILURE';
export const DISABLE_REMOTE_LOGIN_REQUEST = 'DISABLE_REMOTE_LOGIN_REQUEST';
export const DISABLE_REMOTE_LOGIN_SUCCESS = 'DISABLE_REMOTE_LOGIN_SUCCESS';
export const DISABLE_REMOTE_LOGIN_FAILURE = 'DISABLE_REMOTE_LOGIN_FAILURE';

// FIXME: this is not really used, should most likely be removed
export const fetchGithub = () => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `latest/release/ui.salon/${CONF.environment}/`,
    authenticated: false,
    types: [GET_VERSION_REQUEST, GET_VERSION_SUCCESS, GET_VERSION_FAILURE],
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

// TODO: replace all 3 versions of this action with one new beGetServices
export const getCategories = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/category/services/`,
    authenticated: true,
    types: [GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAILURE],
  },
});

export const fetchProductList = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.stockApiRoot,
    endpoint: `product/quick/${salonId}/`,
    authenticated: true,
    types: [PRODUCT_LIST_REQUEST, PRODUCT_LIST_SUCCESS, PRODUCT_LIST_FAILURE],
  },
});

export const getClientsList = (id) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${id}/client/list/`,
    authenticated: true,
    types: [CLIENT_LIST_REQUEST, CLIENT_LIST_SUCCESS, CLIENT_LIST_FAILURE],
    params: { method: 'GET' },
    config: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  },
});

export const fetchSalonState = (id) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${id}/state/`,
    authenticated: true,
    types: [SALON_STATE_REQUEST, SALON_STATE_SUCCESS, SALON_STATE_ERROR],
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export const getUserPermission = (salonId) => {
  // work out whether we need to try to set permissions

  if (!salonId) return { type: SET_USER_PERMISSIONS, salon: null, meta: { analytics: EventTypes.track } };

  return (dispatch, getState) => {
    const attributes = getState()?.cognito?.attributes;

    const mSalonsJson = fromAnyToTrimmed(attributes?.[COGNITO_ATTRIBUTE.salonsManage]);
    const mSalonsList = mSalonsJson ? [...parseJson(mSalonsJson)] : [];

    const rSalonsJson = fromAnyToTrimmed(attributes?.[COGNITO_ATTRIBUTE.salonsAccess]);
    const rSalonsList = rSalonsJson ? [...parseJson(rSalonsJson)] : [];

    if (mSalonsList.includes(salonId)) {
      const params = { permission: USER_ROLE.manager };
      return dispatch({ type: SET_USER_PERMISSIONS, salon: salonId, params });
    }

    if (rSalonsList.includes(salonId)) {
      const params = { permission: USER_ROLE.receptionist };
      return dispatch({ type: SET_USER_PERMISSIONS, salon: salonId, params });
    }

    return Promise.resolve({ type: 'noop:getUserPermission()' });
  };
};

export const updateSalonDetails = (salonDetails) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonDetails.id}/`,
    authenticated: true,
    types: [UPDATE_SALON_DATA_REQUEST, UPDATE_SALON_DATA_SUCCESS, UPDATE_SALON_DATA_FAILURE],
    config: { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(salonDetails) },
  },
});

export const toggleOnlineBoarding = () => ({ type: TOGGLE_ONLINE_BOARDING, meta: { analytics: EventTypes.track } });

export const clearCompletedSaveSalon = () => ({
  type: CLEAR_COMPLETED_SAVE_SALON,
  meta: { analytics: EventTypes.track },
});

export const setRedirectUri = (redirectUri) => ({
  type: SET_REDIRECT_URI,
  redirectUri,
  meta: { analytics: EventTypes.track },
});

// https://staging-core.api.getslick.com/settings/remove/fbintegration/<salon_id>/
export const removeFBIntegration = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `settings/remove/fbintegration/${salonId}/`,
    authenticated: true,
    types: [REMOVE_FB_INTEGRATION_REQUEST, REMOVE_FB_INTEGRATION_SUCCESS, REMOVE_FB_INTEGRATION_FAILURE],
    config: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status: 'deleted' }),
    },
  },
});

export const resetPin = (salonId, stylistId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/stylist/pin/${stylistId}/reset/`,
    authenticated: true,
    types: [RESET_PIN_REQUEST, RESET_PIN_SUCCESS, RESET_PIN_FAILURE],
    config: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ stylist: stylistId, salon: salonId }),
    },
  },
});

export const emailPin = (salonId, stylistId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/stylist/pin/${stylistId}/email/`,
    authenticated: true,
    types: [EMAIL_PIN_REQUEST, EMAIL_PIN_SUCCESS, EMAIL_PIN_FAILURE],
    config: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  },
});

export const removeAccess = (salonId, userId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/users/${userId}/remove_access/`,
    authenticated: true,
    types: [REMOVE_ACCESS_REQUEST, REMOVE_ACCESS_SUCCESS, REMOVE_ACCESS_FAILURE],
    params: { userId },
    config: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  },
});

export const resetRemovedAccess = () => ({ type: RESET_REMOVED_ACCESS });
